import { ReactNode } from 'react';
interface SvgBtnBoxProps {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const SvgBtnBox = ({ children, className, onClick }: SvgBtnBoxProps) => {
  return (
    <div
      className={` cursor-pointer inline-flex items-center justify-center p-1 rounded-[6px] hover:bg-[#F5F5F5] ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
